import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import './support.css';

const Support = () => {
  return (
    <div className="support-container">
      <div className="support-header">
        <h1 className="support-title">Contact Support</h1>
        <p className="support-subtitle">We're here to assist you 24/7</p>
      </div>
      
      <div className="support-content">
        <div className="support-card">
          <div className="support-item">
            <FontAwesomeIcon icon={faEnvelope} className="support-icon" />
            <div className="support-details">
              <h3>Email Support</h3>
              <a href="mailto:cse@just.edu.bd" className="support-link">
                cse@just.edu.bd
              </a>
            </div>
          </div>

          <div className="support-item">
            <FontAwesomeIcon icon={faPhone} className="support-icon" />
            <div className="support-details">
              <h3>Phone Support</h3>
              <a href="tel:+8801729885196" className="support-link">
                +880 1729 885196
              </a>
            </div>
          </div>

          <div className="support-item">
            <FontAwesomeIcon icon={faWhatsapp} className="support-icon" />
            <div className="support-details">
              <h3>WhatsApp Support</h3>
              <a 
                href="https://wa.me/8801744899779" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="support-link"
              >
                +880 1744 899779
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Support;